module.exports = __webpack_public_path__ + "static/img/mermaidFishing-s.37adcf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/mermaidFishing-s.png
// module id = ZFFU
// module chunks = 0